// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.profilePic_dashboard__JPxt7 {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
  padding-right: 0px;
}

.profilePic_dashboardContain__IMIGu {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.profilePic_bodythemedark__Xwoji .profilePic_dashboardContain__IMIGu,
.profilePic_bodythemedark__Xwoji .profilePic_dashboard__JPxt7,
.profilePic_bodythemedark__Xwoji .profilePic_cont2__saMR8 {
  background-Color: #0f1824;
}

.profilePic_top_header__UU2J1 .profilePic_top_header_inner__Sl2vE {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.profilePic_cont2__saMR8 {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.profilePic_subLink__VStYM svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.profilePic_cst_vendr__ESENQ input {
  min-height: 35px !important;
}

.profilePic_cst_vendr__ESENQ .profilePic_form-control__Tp7ew {
  background-color: #f5f6fa;
  border: none;
}

.profilePic_footer__tBwon {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.profilePic_bodythemelight__HLdOE {
  background-color: #fff;
  padding-top: 90px;
}

.profilePic_bodythemedark__Xwoji {
  background-color: #132337;
  padding-top: 90px;
}

.profilePic_bodythemeNew__wnugN {
  background-color: #f5f6fa;
}

/* 
Header Navbar Theme
*/
.profilePic_headerthemelight__PilSB {
  background-color: #fff;
}

.profilePic_headerthemedark__iPgL8 {
  background-color: #132337;
}

.profilePic_top_header__UU2J1 {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.profilePic_menuthemelight__2Ss4L {
  background-color: #f5f6fa;
}

.profilePic_menuthemedark__QVe1W {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.profilePic_menulinklight__lsCgn span {
  color: #666666 !important;
}

.profilePic_menulinklight__lsCgn a {
  color: #CBCBCB !important;
}

.profilePic_menulinklight__lsCgn:hover span,
.profilePic_menulinklight__lsCgn:hover a {
  color: #fff !important;
}

.profilePic_menulinkdarkSelected__zso2- {
  background-color: #1c2e45;
  color: #3b82f6;
}

.profilePic_menuthemelight__2Ss4L .profilePic_menulinklightSelected__wjHCW {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.profilePic_menulinkdark__zJdzP {
  color: #92afd3 !important;
}

.profilePic_menulinklight__lsCgn:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.profilePic_menulinklight__lsCgn .profilePic_sub_arrow__Ut93b svg path {
  stroke: #CBCBCB !important;
}

.profilePic_menulinklight__lsCgn:hover .profilePic_sub_arrow__Ut93b svg path {
  stroke: #fff !important;
}

.profilePic_menulinkdark__zJdzP .profilePic_sub_arrow__Ut93b svg path {
  stroke: #92afd3 !important;
}

.profilePic_menulinkdark__zJdzP:hover .profilePic_sub_arrow__Ut93b svg path {
  stroke: #fff !important;
}

.profilePic_menulinklight__lsCgn:hover svg path,
.profilePic_menulinklightSelected__wjHCW svg path {
  fill: #fff !important;
}

.profilePic_menulinkdark__zJdzP:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.profilePic_headinglight__xg0Xf {
  color: #60677e;
}

.profilePic_headingdark__htXGr {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.profilePic_searchboxlight__ae0aZ {
  background-color: #fff;
  border: none;
}

.profilePic_searchboxdark__1jar8 {
  background-color: #132337;
  color: #fff;
  border: none;
}

.profilePic_searchboxdark__1jar8::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.profilePic_tableheadlight__FifrR {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.profilePic_tableheadlight__FifrR th {
  color: #fff;
}

thead .profilePic_tableheadlight__FifrR th:first-child,
thead .profilePic_tableheaddark__7Y6BR th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .profilePic_tableheadlight__FifrR th:last-child,
thead .profilePic_tableheaddark__7Y6BR th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.profilePic_table__HyVds.profilePic_table-borderless__BV-NV {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.profilePic_tableheaddark__7Y6BR {
  background-color: #132337;
  color: #fff;
}

.profilePic_table-borderless__BV-NV tr:nth-child(even) {
  background-color: #F9FAFB;
}

.profilePic_table-borderless__BV-NV .profilePic_left-section__MjWNW {
  padding-top: 10px;
}

.profilePic_tablebodylight__66ENh td,
.profilePic_tablebodydark__D2j26 td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.profilePic_tablebodylight__66ENh {
  background-color: #fff;
}
.profilePic_tablebodylight__66ENh:hover {
  background-color: #fff;
  cursor: auto;
}
.profilePic_tablebodylight__66ENh p {
  line-height: 24px;
}

.profilePic_tablebodydark__D2j26 {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.profilePic_tablebodydark__D2j26:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.profilePic_paginationlight__3KxA8 {
  color: #60677e !important;
  font-size: 13px !important;
}

.profilePic_paginationdark__-hPqT {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.profilePic_formthemelight__VoAYe {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.profilePic_formthemedark__q3ROm {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.profilePic_formthemedark__q3ROm ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.profilePic_viewformlight__7Bm4E {
  background-color: #f3f6f9;
}

.profilePic_permissionboxlight__O08yh {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.profilePic_permissionboxdark__9naD0 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.profilePic_errormsgclr__wj5Bj {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.profilePic_graphclrlight__OG2D2 {
  background-color: #fff;
}

.profilePic_graphclrdark__liaB8 {
  background-color: #132337;
}

/* 
Counter theme
*/
#profilePic_card1bglight__8i9cS {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#profilePic_card1bgdark__kZ1aJ {
  background: #392f28;
}

#profilePic_card2bglight__w6FpT {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#profilePic_card2bgdark__mm3Tx {
  background: #1c3238;
}

#profilePic_card3bglight__Ovh5i {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#profilePic_card3bgdark__Pdved {
  background: #3a2434;
}

#profilePic_card4bglight__Bp80a {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#profilePic_card4bgdark__T9zfK {
  background: #2f264f;
}

#profilePic_card1bgdark__kZ1aJ a,
#profilePic_card1bgdark__kZ1aJ p,
#profilePic_card2bgdark__mm3Tx a,
#profilePic_card2bgdark__mm3Tx p,
#profilePic_card3bgdark__Pdved a,
#profilePic_card3bgdark__Pdved p,
#profilePic_card4bgdark__T9zfK a,
#profilePic_card4bgdark__T9zfK p {
  color: #fff;
}

/* 
Action button theme
*/
.profilePic_actionbtnlight__YVuTW {
  color: rgba(70, 71, 91, 0.8705882353);
}

.profilePic_actionbtndark__w\\+xsH {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.profilePic_profiledropdownlight__wpumk {
  background-color: #fff;
}

.profilePic_profiledropdowndark__bSVZz {
  background-color: #151521;
}

.profilePic_settingsection__kIfIu #profilePic_addform__hkTYm.profilePic_formthemedark__q3ROm .profilePic_savebtn__1h\\+DM {
  background-color: #3b82f6;
  color: #fff;
}

#profilePic_addform__hkTYm.profilePic_formthemedark__q3ROm .profilePic_savebtn__1h\\+DM {
  background-color: #3b82f6;
  color: #fff;
}

.profilePic_profile_conatiner__-jZMC {
  border-radius: 5px !important;
}

.profilePic_bodythemedark__Xwoji .profilePic_ag-theme-alpine__IEZg2 .profilePic_ag-row__bHHn9 {
  background: #000 !important;
}

.profilePic_bodythemedark__Xwoji .profilePic_formbtn__-PVDt {
  background-color: #3b82f6;
}

.profilePic_bodythemedark__Xwoji .profilePic_formbtn__-PVDt:hover {
  background-color: #2563eb;
}

.profilePic_bodythemedark__Xwoji .profilePic_resetbtn__sI9bP {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.profilePic_bodythemedark__Xwoji .profilePic_resetbtn__sI9bP:hover {
  background-color: #3b82f6;
}

.profilePic_headingdark__htXGr span {
  background-color: #132337;
}

.profilePic_resetbtn__sI9bP {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.profilePic_resetbtn__sI9bP:hover,
.profilePic_resetbtn__sI9bP:active,
.profilePic_resetbtn__sI9bP:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.profilePic_addBtn__FYpoo {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.profilePic_addDltBtn__xf7b6 {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.profilePic_addbtnlight__Hl6y0 {
  background-color: #38A169;
}

.profilePic_addbtndark__lJxYj {
  background-color: #3b82f6;
}

.profilePic_addbtndark__lJxYj:hover {
  background-color: #2563eb;
}

.profilePic_formthemedark__q3ROm label {
  color: #92afd3;
}

.profilePic_addBtn__FYpoo svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.profilePic_addBtn__FYpoo:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.profilePic_cust_addBtn__OFVhY.profilePic_addBtn__FYpoo svg {
  top: 2px;
}

.profilePic_deleteBtn__cwMHm {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.profilePic_deleteBtn__cwMHm {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.profilePic_deleteBtn__cwMHm:active,
.profilePic_deleteBtn__cwMHm:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.profilePic_deleteBtn__cwMHm svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.profilePic_deleteBtn__cwMHm:hover,
.profilePic_deleteBtn__cwMHm:active,
.profilePic_deleteBtn__cwMHm:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.profilePic_confirmBtn__d3Z\\+t {
  background-color: #131F43 !important;
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
}

.profilePic_confirmBtn__d3Z\\+t:hover,
.profilePic_confirmBtn__d3Z\\+t:active,
.profilePic_confirmBtn__d3Z\\+t:focus {
  background-color: #0f1824 !important;
}

.profilePic_confirmBtn__d3Z\\+t svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.profilePic_delPopContainer__Dc\\+CD .profilePic_modal-body__Ijxbc {
  padding: 35px;
  text-align: center;
}

.profilePic_delPopContainer__Dc\\+CD .profilePic_delet_icon__enafO {
  margin-bottom: 11px;
}

.profilePic_delPopContainer__Dc\\+CD p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.profilePic_arrowback__Qcy5h svg {
  fill: #000;
}

.profilePic_bodythemedark__Xwoji .profilePic_arrowback__Qcy5h {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.profilePic_bodythemedark__Xwoji .profilePic_arrowback__Qcy5h svg {
  fill: #3b82f6;
}

.profilePic_bodythemedark__Xwoji .profilePic_drpdwn_btn__7J9lx {
  background-color: #132337;
}

.profilePic_bodythemedark__Xwoji .profilePic_empname__tXDxk {
  color: #92afd3 !important;
}

.profilePic_bodythemedark__Xwoji .profilePic_navitemli__hbNv8 a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.profilePic_bodythemedark__Xwoji .profilePic_tabnavli__54qZg a.profilePic_settingsgeneral__HG2OY,
.profilePic_bodythemedark__Xwoji .profilePic_tabnavli__54qZg a.profilePic_settingslinks__Shzq-:hover {
  background-color: #3b82f6;
  color: #fff;
}

.profilePic_bodythemedark__Xwoji .profilePic_tabnavli__54qZg a.profilePic_settingslinks__Shzq- {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.profilePic_headerthemedark__iPgL8 .profilePic_dropdown_menu_contain__UzzMt {
  background-color: #1c2e45;
  color: #fff;
}

.profilePic_headerthemedark__iPgL8 .profilePic_dropdown_menu_contain__UzzMt ul li a,
.profilePic_headerthemedark__iPgL8 .profilePic_dropdown_menu_contain__UzzMt .profilePic_dropdown_item__PXcOe,
.profilePic_headerthemedark__iPgL8 .profilePic_dropdown_menu_contain__UzzMt .profilePic_dropdown_item__PXcOe h5 {
  color: #fff;
}

.profilePic_headerthemedark__iPgL8 .profilePic_dropdown_menu_contain__UzzMt ul li a:hover,
.profilePic_headerthemedark__iPgL8 .profilePic_dropdown_menu_contain__UzzMt .profilePic_dropdown_item__PXcOe:hover {
  background-color: #132337;
  color: #fff;
}

.profilePic_dropdown_item__PXcOe:active {
  background-color: #F5F6FA;
}

.profilePic_profile_arrrow_dwn__oUjg2 {
  stroke: #132337;
}

.profilePic_headerthemedark__iPgL8 .profilePic_profile_arrrow_dwn__oUjg2 {
  stroke: #fff;
}

.profilePic_dateinputbox1__QnA5w input,
.profilePic_dateinputbox1__QnA5w span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.profilePic_delPopContainer__Dc\\+CD .profilePic_modal-content__dUSXG {
  border-radius: 10px;
  min-width: 399px;
}

.profilePic_larg_model__TJTEo .profilePic_modal-dialog__oJMWf {
  max-width: 100% !important;
}

.profilePic_larg_model__TJTEo .profilePic_modal-content__dUSXG {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.profilePic_larg_model__TJTEo .profilePic_modal-header__T95WG {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .profilePic_btn-primary__pOjcJ:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.profilePic_form-select__4VlO2 {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .profilePic_CustomTable_tableheadlight__HuHZw__k4Q1x th:first-child,
thead .profilePic_CustomTable_tableheaddark__nwqb4__R\\+14e th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
  position: absolute;
}

@media only screen and (max-width: 1200px) {
  .profilePic_tableheadlight__FifrR th {
    min-width: 270px;
  }
}
@media only screen and (max-width: 1024px) {
  .profilePic_dashboard__JPxt7 {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden !important;
  }
  .profilePic_cont2__saMR8 {
    height: auto !important;
    padding-bottom: 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .profilePic_sectionright__6xmsp {
    float: unset !important;
  }
  .profilePic_dashboard__JPxt7 {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .profilePic_cont2__saMR8 {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .profilePic_bodythemelight__HLdOE,
.profilePic_bodythemedark__Xwoji {
    padding-top: 110px;
  }
  .profilePic_delPopContainer__Dc\\+CD .profilePic_modal-content__dUSXG {
    min-width: 100%;
  }
  .profilePic_delPopContainer__Dc\\+CD .profilePic_modal-body__Ijxbc {
    padding: 15px;
  }
  .profilePic_larg_model__TJTEo .profilePic_modal-content__dUSXG {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .profilePic_exer_modal_contain__Y303a .profilePic_modal-dialog__oJMWf {
    max-width: 1055px;
  }
  .profilePic_delPopContainer__Dc\\+CD .profilePic_modal-dialog__oJMWf {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 120px;
  } */
}
/* vk new changes */
.profilePic_active_show_outer__ecfb9 h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: Urbanist;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 768px) {
  .profilePic_active_show_outer__ecfb9 h2 {
    margin-top: 15px;
  }
}
.profilePic_active_show_outer__ecfb9 .profilePic_active_show_inner__ywVsc {
  width: 100%;
  display: block;
}
.profilePic_active_show_outer__ecfb9 .profilePic_active_show_inner__ywVsc .profilePic_act_box_img__pQOvX {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .profilePic_active_show_outer__ecfb9 .profilePic_active_show_inner__ywVsc .profilePic_act_box_img__pQOvX {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.profilePic_active_show_outer__ecfb9 .profilePic_active_show_inner__ywVsc .profilePic_act_box_img__pQOvX img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.profilePic_active_show_outer__ecfb9 .profilePic_active_show_inner__ywVsc .profilePic_act_box_cnt__Q0\\+EM {
  width: 100%;
  display: block;
}
.profilePic_active_show_outer__ecfb9 .profilePic_active_show_inner__ywVsc .profilePic_act_box_cnt__Q0\\+EM svg {
  flex-shrink: 0;
}
.profilePic_active_show_outer__ecfb9 .profilePic_active_show_inner__ywVsc .profilePic_act_box_cnt__Q0\\+EM .profilePic_act_box_bdg__uS3WM {
  width: 100%;
  margin-bottom: 12px;
}
.profilePic_active_show_outer__ecfb9 .profilePic_active_show_inner__ywVsc .profilePic_act_box_cnt__Q0\\+EM .profilePic_act_box_bdg__uS3WM span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.profilePic_active_show_outer__ecfb9 .profilePic_active_show_inner__ywVsc .profilePic_act_box_cnt__Q0\\+EM .profilePic_act_box_bdg__uS3WM .profilePic_sold__afaUn {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.profilePic_active_show_outer__ecfb9 .profilePic_active_show_inner__ywVsc .profilePic_act_box_cnt__Q0\\+EM h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.profilePic_active_show_outer__ecfb9 .profilePic_active_show_inner__ywVsc .profilePic_act_box_cnt__Q0\\+EM p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.profilePic_active_show_outer__ecfb9 .profilePic_active_show_inner__ywVsc .profilePic_act_box_cnt__Q0\\+EM p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}
.profilePic_active_show_outer__ecfb9 .profilePic_active_show_inner__ywVsc .profilePic_act_box_cnt__Q0\\+EM p .profilePic_timezone_code_pill__UO0TG {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

/* vk new changes */
#profilePic_attent_details_row1__eGaU8 {
  margin-bottom: 0 !important;
}

.profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- .profilePic_attent_details_inner_l__IHikX img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: cover;
}
.profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- .profilePic_attent_details_inner_r__lr-A3 {
  flex: 1 1;
}
.profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- .profilePic_attent_details_inner_r__lr-A3 .profilePic_attent_details_row__DPygr {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- .profilePic_attent_details_inner_r__lr-A3 .profilePic_attent_details_row__DPygr {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- .profilePic_attent_details_inner_r__lr-A3 .profilePic_attent_details_row__DPygr .profilePic_attent_details_row_box__DDFLY {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- .profilePic_attent_details_inner_r__lr-A3 .profilePic_attent_details_row__DPygr .profilePic_attent_details_row_box__DDFLY {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- .profilePic_attent_details_inner_r__lr-A3 .profilePic_attent_details_row__DPygr .profilePic_attent_details_row_box__DDFLY {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- .profilePic_attent_details_inner_r__lr-A3 .profilePic_attent_details_row__DPygr .profilePic_attent_details_row_box__DDFLY p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- .profilePic_attent_details_inner_r__lr-A3 .profilePic_attent_details_row__DPygr .profilePic_attent_details_row_box__DDFLY h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- .profilePic_attent_details_inner_r__lr-A3 .profilePic_attent_details_row_last__UTfPc {
  margin-bottom: 0px !important;
}
.profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- .profilePic_attent_details_inner_r__lr-A3 .profilePic_attent_details_row_last__UTfPc.profilePic_interesting_fact__zkBjI {
  padding-top: 30px;
}
.profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- .profilePic_attent_details_inner_r__lr-A3 .profilePic_attent_details_row_last__UTfPc.profilePic_interesting_fact__zkBjI .profilePic_attent_details_row_box__DDFLY {
  width: 100%;
}
.profilePic_attent_details__b2Uxf .profilePic_attent_details_inner__AkUP- .profilePic_attent_details_inner_r__lr-A3 .profilePic_attent_details_row_last__UTfPc.profilePic_interesting_fact__zkBjI .profilePic_attent_details_row_box__DDFLY h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.profilePic_showbox_sec__eifjN {
  display: flex;
  justify-content: flex-start;
  gap: 0;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 500px) {
  .profilePic_showbox_sec__eifjN {
    justify-content: center;
  }
}

.profilePic_show_box_main__v58Wx {
  margin: 10px 0px;
}
.profilePic_show_box_main__v58Wx .profilePic_show_box__y1yHc {
  min-height: 600px;
  width: 300px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .profilePic_show_box_main__v58Wx .profilePic_show_box__y1yHc {
    margin-right: 18px;
  }
}
@media (max-width: 767px) {
  .profilePic_show_box_main__v58Wx .profilePic_show_box__y1yHc {
    min-height: 500px;
    width: 200px !important;
  }
}
.profilePic_show_box_main__v58Wx .profilePic_show_box__y1yHc img {
  max-height: 400px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .profilePic_show_box_main__v58Wx .profilePic_show_box__y1yHc img {
    max-height: 300px !important;
  }
}
.profilePic_show_box_main__v58Wx .profilePic_show_box__y1yHc:last-child {
  margin-right: 0px !important;
}
.profilePic_show_box_main__v58Wx .profilePic_no_show_box__t9Ofu {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .profilePic_show_box_main__v58Wx .profilePic_no_show_box__t9Ofu {
    width: 250px !important;
  }
}
.profilePic_show_box_main__v58Wx .profilePic_no_show_box__t9Ofu img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .profilePic_show_box_main__v58Wx .profilePic_no_show_box__t9Ofu img {
    max-height: 350px !important;
  }
}
.profilePic_show_box_main__v58Wx .profilePic_no_show_box__t9Ofu h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .profilePic_show_box_main__v58Wx .profilePic_no_show_box__t9Ofu h6 {
    font-size: 20px;
  }
}

.profilePic_attent_flex__YF6Ld {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.profilePic_attent_flex__YF6Ld h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

.profilePic_profilepicdiv__1MwzM {
  padding: 10px;
  border-radius: 5px;
  text-align: center;
}
@media screen and (max-width: 768px) {
  .profilePic_profilepicdiv__1MwzM {
    padding: 0 10px 10px 10px;
  }
}

.profilePic_profilepic__6MpcF {
  width: 110px;
  height: 110px;
  border-radius: 5px;
}

.profilePic_editbtnsection__cDMXa {
  text-align: center;
  margin-top: 0%;
}

#profilePic_penicon__3jn1F {
  margin-left: 106px;
  font-size: 14px;
  background-color: #60677e;
  padding: 5px;
  border-radius: 50%;
  color: #e9ecef;
  cursor: pointer;
}
#profilePic_penicon__3jn1F:hover {
  background-color: #131F43;
}

.profilePic_uploadfield__xrjjw {
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  padding: 6px 0px 0px 3px;
  width: 90px;
  margin-left: 130%;
  margin-top: -55%;
  border-radius: 5px;
}

.profilePic_sizeHint__WUBgz {
  font-size: 11px;
  color: #6c757d;
  display: block;
  margin-top: 4px;
}

.profilePic_uploadicon__blB0i {
  color: #1d1d1d;
  font-size: 18px;
  cursor: pointer;
}
.profilePic_uploadicon__blB0i:hover {
  color: #131F43;
}

.profilePic_crossicon__ou0Mn {
  color: #1d1d1d;
  font-size: 16px;
  margin-left: 40px;
  cursor: pointer;
}
.profilePic_crossicon__ou0Mn:hover {
  color: #131F43;
}

@media only screen and (max-width: 600px) {
  .profilePic_editbtnsection__cDMXa {
    margin-top: 10px;
  }
}
@media only screen and (max-width: 600px) {
  .profilePic_editbtnsection__cDMXa {
    margin-top: 0;
  }
}
@media only screen and (max-width: 430px) {
  .profilePic_uploadfield__xrjjw {
    margin-left: 95%;
    margin-top: -6%;
  }
}
@media only screen and (max-width: 400px) {
  .profilePic_editbtnsection__cDMXa {
    margin-top: 0;
  }
}
@media only screen and (max-width: 350px) {
  .profilePic_editbtnsection__cDMXa {
    margin-top: 0;
  }
  #profilePic_penicon__3jn1F {
    margin-left: 90px;
  }
  .profilePic_uploadfield__xrjjw {
    margin-left: 70%;
    margin-top: -5%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/ProfilePic/profilePic.module.scss"],"names":[],"mappings":"AAAA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,gBAAA;EACA,kBAAA;ACvEF;;AD0EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACvEF;;AD0EA;;;EAGE,yBApEoB;ACHtB;;AD0EA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACvEF;;AD0EA;;CAAA;AAIA;EACE,wBA1CU;EA2CV,UA1CS;EA2CT,kBAAA;EACA,aAlDiB;EAmDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA;;;GAAA;ACrEF;;AD2EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACxEF;;AD6EA;EACE,2BAAA;AC1EF;;AD6EA;EACE,yBAAA;EACA,YAAA;AC1EF;;AD8EA;EACE,YAAA;AC3EF;;AD8EA;EACE,sBA9GY;ACmCd;;AD8EA;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AC3EF;;AD8EA;EACE,yBArIgB;EAsIhB,iBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,sBAtIY;AC2Dd;;AD8EA;EACE,yBArJgB;AC0ElB;;AD8EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBA1KgB;AC+FlB;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;EAEE,sBAAA;AC3EF;;AD8EA;EACE,yBA5LsB;EA6LtB,cAvMkB;AC4HpB;;AD8EA;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;;EAEE,qBAAA;AC3EF;;AD8EA;EACE,yBArOsB;EAsOtB,WA7NY;ACkJd;;AD8EA;;CAAA;AAGA;EACE,cAjOe;ACsJjB;;AD8EA;EACE,cArOe;AC0JjB;;AD8EA;;CAAA;AAGA;EACE,sBA/OY;EAgPZ,YAAA;AC3EF;;AD8EA;EACE,yBA/PgB;EAgQhB,WArPY;EAsPZ,YAAA;AC3EF;;AD8EA;EACE,cAvPe;AC4KjB;;AD8EA;;CAAA;AAGA;EACE,yBA9Sc;EA+Sd,8BAAA;AC3EF;;AD8EA;EACE,WAtQY;AC2Ld;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,oCAAA;EACA,gCAAA;AC3EF;;AD8EA;EACE,yBAzRkB;EA0RlB,WAlSY;ACuNd;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,iBAAA;AC3EF;;AD8EA;;EAEE,+BAAA;EACA,iBAAA;AC3EF;;AD8EA;EACE,sBApTY;ACyOd;AD6EE;EACE,sBAvTU;EAwTV,YAAA;AC3EJ;AD6EE;EACA,iBAAA;AC3EF;;ADgFA;EACE,0CAAA;EACA,cA/Te;ACkPjB;AD+EE;EACE,yCAAA;EACA,eAAA;AC7EJ;;ADiFA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;;CAAA;AAGA;EACE,sBA3VY;EA4VZ,yBAAA;EACA,qDAAA;AC9EF;;ADiFA;EACE,yBAzVkB;EA0VlB,yBAAA;EACA,eAAA;AC9EF;ADgFE;EACE,cAnWa;ACqRjB;;ADmFA;;CAAA;AAGA;EACE,yBAlXgB;ACkSlB;;ADmFA;EACE,yBAAA;EACA,yBAAA;AChFF;;ADmFA;EACE,yBAlYoB;EAmYpB,yBAAA;AChFF;;ADmFA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AChFF;;ADmFA;;CAAA;AAGA;EACE,sBAtYY;ACsTd;;ADmFA;EACE,yBAlYkB;ACkTpB;;ADoFA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAnZY;ACkUd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA5ZY;AC2Ud;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBAraY;ACoVd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA9aY;AC6Vd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;;;;;;;;EAQE,WA7bY;AC4Wd;;ADoFA;;CAAA;AAGA;EACE,qCAAA;ACjFF;;ADoFA;EACE,cArce;ACoXjB;;ADqFA;;CAAA;AAGA;EACE,sBAAA;AClFF;;ADqFA;EACE,yBAAA;AClFF;;ADqFA;EACE,yBAzekB;EA0elB,WAzdY;ACuYd;;ADqFA;EACE,yBA9ekB;EA+elB,WA9dY;AC4Yd;;ADqFA;EACE,6BAAA;AClFF;;ADqFA;EACE,2BAAA;AClFF;;ADqFA;EACE,yBA3fkB;ACyapB;;ADqFA;EACE,yBA9fwB;AC4a1B;;ADqFA;EACE,WAlfY;EAmfZ,6BAAA;EACA,yBAAA;AClFF;;ADqFA;EACE,yBAzgBkB;ACubpB;;ADsFA;EACE,yBAxgBgB;ACqblB;;ADsFA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ACnFF;;ADsFA;;;EAGE,oCAAA;EACA,sBAAA;ACnFF;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WAphBY;EAqhBZ,yBAhjBY;EAijBZ,YAAA;EACA,eAAA;EACA,gBA3kBc;ACwfhB;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WA9hBY;EA+hBZ,yBA1jBY;EA2jBZ,YAAA;EACA,eAAA;EACA,gBArlBc;ACkgBhB;;ADsFA;EACE,yBAjkBY;AC8ed;;ADsFA;EACE,yBA3jBkB;ACwepB;;ADsFA;EACE,yBA9jBwB;AC2e1B;;ADsFA;EACE,cApkBiB;ACifnB;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpFF;;ADuFA;EACE,WA7jBY;EA8jBZ,yBAzlBY;EA0lBZ,YAAA;ACpFF;;ADuFA;EACE,QAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBA7lBW;EA8lBX,WA1kBY;EA2kBZ,eAAA;EACA,gBA/nBc;EAgoBd,YAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBAvmBW;EAwmBX,WAplBY;EAqlBZ,eAAA;EACA,gBAzoBc;EA0oBd,YAAA;ACpFF;;ADuFA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADuFA;;;EAGE,yBA9nBW;EA+nBX,WA3mBY;EA4mBZ,YAAA;ACpFF;;ADuFA;EACE,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ACpFF;;ADuFA;;;EAGE,oCAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADyFA;EACE,aAAA;EACA,kBAAA;ACtFF;;ADyFA;EACE,mBAAA;ACtFF;;ADyFA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACtFF;;ADyFA;EACE,UAAA;ACtFF;;ADyFA;EACE,yCA3qBc;EA4qBd,cAhrBkB;AC0lBpB;;ADyFA;EACE,aAprBkB;AC8lBpB;;ADyFA;EACE,yBAhrBgB;AC0lBlB;;ADyFA;EACE,yBAAA;ACtFF;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA/qBY;ACylBd;;ADyFA;;EAEE,yBArsBkB;EAssBlB,WArrBY;AC+lBd;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA3rBY;ACqmBd;;ADyFA;EACE,yBAxsBsB;EAysBtB,WAhsBY;AC0mBd;;ADyFA;;;EAGE,WAtsBY;ACgnBd;;ADyFA;;EAEE,yBAttBgB;EAutBhB,WA5sBY;ACsnBd;;ADyFA;EACE,yBA9vBO;ACwqBT;;ADyFA;EACE,eA/tBgB;ACyoBlB;;ADyFA;EACE,YAxtBY;ACkoBd;;ADyFA;;EAEE,sBAAA;ACtFF;;ADyFA,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AC1FF;;AD6FA;EACE,0BAAA;AC1FF;;AD6FA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AC1FF;;AD6FA;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AC1FF;;AD6FA;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AC1FF;;AD6FA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AC1FF;;AD6FA;;EAEE,0BAAA;EACA,aAAA;AC1FF;;AD6FA;EACE,kBAAA;EACA,kBAAA;AC1FF;;AD6FA;EACE;IACE,gBAAA;EC1FF;AACF;AD6FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;EC3FF;ED8FA;IACE,uBAAA;IACA,+BAAA;EC5FF;AACF;AD+FA;EACE;;IAAA;AC3FF;ADgGA;EACE;IACE,uBAAA;EC9FF;EDiGA;IACE,6BAAA;EC/FF;AACF;ADkGA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;EChGF;EDmGA;;IAEE,kBAAA;ECjGF;EDoGA;IACE,eAAA;EClGF;EDqGA;IACE,aAAA;ECnGF;EDsGA;IACE,8BAAA;IACA,aAAA;ECpGF;AACF;ADuGA;EACE;IACE,iBAAA;ECrGF;EDwGA;IACE,gBAAA;ECtGF;EDyGA;;KAAA;ACrGF;AD0GA,mBAAA;AAGE;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC1GJ;AD2GI;EAPF;IAQI,gBAAA;ECxGJ;AACF;AD2GE;EACE,WAAA;EACA,cAAA;ACzGJ;AD2GI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;ACzGN;AD0GM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;ECvGN;AACF;ADwGM;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ACtGR;AD0GI;EACE,WAAA;EACA,cAAA;ACxGN;ADyGA;EACE,cAAA;ACvGF;ADyGM;EACE,WAAA;EACA,mBAAA;ACvGR;ADyGQ;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ACvGV;AD0GQ;EACE,kFAAA;ACxGV;AD6GM;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AC3GR;AD8GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AC5GR;AD8GQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AC5GV;AD+GQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AC7GV;;ADoHA,mBAAA;AACA;EACI,2BAAA;ACjHJ;;ADoHE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ACjHJ;ADmHI;EATF;IAUI,yBAAA;EChHJ;AACF;ADkHI;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EC/GJ;AACF;ADkHM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AChHR;ADoHI;EACE,SAAA;AClHN;ADoHM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AClHR;ADoHQ;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;ECjHR;AACF;ADmHQ;EACE,SAAA;EACA,UAAA;ACjHV;ADmHU;EAJF;IAKI,gCAAA;IACA,sBAAA;EChHV;AACF;ADkHU;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;EC/GV;AACF;ADiHU;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC/GZ;ADkHU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AChHZ;ADqHM;EACE,6BAAA;ACnHR;ADoHQ;EACE,iBAAA;AClHV;ADmHU;EACE,WAAA;ACjHZ;ADkHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AChHd;;ADyHC;EACK,aAAA;EACF,2BAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;ACtHJ;ADuHI;EANH;IAOK,uBAAA;ECpHJ;AACF;;ADsHA;EACE,gBAAA;ACnHF;ADqHE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ACnHJ;ADqHI;EARF;IASI,kBAAA;EClHJ;AACF;ADmHI;EAXF;IAYI,iBAAA;IACA,uBAAA;EChHJ;AACF;ADkHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AChHN;ADkHM;EALF;IAMI,4BAAA;EC/GN;AACF;ADkHI;EACE,4BAAA;AChHN;ADoHE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AClHJ;ADoHI;EALF;IAMI,uBAAA;ECjHJ;AACF;ADmHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ACjHN;ADmHM;EALF;IAMI,4BAAA;EChHN;AACF;ADkHI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AChHN;ADiHM;EARF;IASI,eAAA;EC9GN;AACF;;ADqHA;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;AClHF;ADoHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AClHJ;;AA1lCC;EACG,aAAA;EACA,kBAAA;EACA,kBAAA;AA6lCJ;AA5lCI;EAJH;IAKO,yBAAA;EA+lCN;AACF;;AA5lCA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;AA+lCJ;;AA7lCA;EACI,kBAAA;EACA,cAAA;AAgmCJ;;AA7lCA;EACI,kBAAA;EACA,eAAA;EACA,yBDmCa;EClCb,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAgmCJ;AA9lCK;EACG,yBDsCW;AC0jCnB;;AA5lCA;EACI,yBAAA;EACA,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AA+lCJ;;AA5lCA;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AA+lCF;;AA7lCA;EACI,cDKU;ECJV,eAAA;EACA,eAAA;AAgmCJ;AA9lCI;EACI,cDYW;AColCnB;;AA7lCA;EACI,cDJU;ECKV,eAAA;EACA,iBAAA;EACA,eAAA;AAgmCJ;AA9lCI;EACG,cDEY;AC8lCnB;;AA1lCA;EACI;IACI,gBAAA;EA6lCN;AACF;AA1lCE;EACE;IACI,aAAA;EA4lCN;AACF;AAzlCE;EACE;IACI,gBAAA;IACA,eAAA;EA2lCN;AACF;AAvlCA;EACI;IACI,aAAA;EAylCN;AACF;AAplCA;EACI;IACI,aAAA;EAslCN;EAplCE;IACI,iBAAA;EAslCN;EAplCE;IACI,gBAAA;IACA,eAAA;EAslCN;AACF","sourcesContent":["/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  overflow-y: auto;\n  padding-right: 0px;\n}\n\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-Color: $mainBg;\n  border-radius: 8px;\n}\n\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-Color: $darkTheme_darkBlue;\n}\n\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /*height: calc(100vh - 160px);*/\n  height: 100%;\n  min-height: auto !important;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.cst_vendr input {\n  min-height: 35px !important;\n}\n\n.cst_vendr .form-control {\n  background-color: #f5f6fa;\n  border: none;\n}\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n.bodythemeNew {\n  background-color: #f5f6fa;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: #f5f6fa;\n}\n\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinklight:hover svg path,\n.menulinklightSelected svg path {\n  fill: #fff !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.tableheadlight th {\n  color: $white-color;\n}\n\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\n\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\n\nth:first-child {\n  border-radius: 0px;\n}\n\ntd:last-child {\n  border-radius: 0px;\n}\n\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: $white-color;\n    cursor: auto;\n  }\n  p{\n  line-height: 24px;\n}\n\n}\n\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border-radius: 5px !important;\n  background-color: transparent !important;\n  border: solid 1px $primary-color !important;\n  color: $primary-color !important;\n  min-width: 113px !important;\n}\n\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color !important;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addDltBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color !important;\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $darkTheme_darkBlue !important;\n}\n\n.confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 35px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 20px;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {}\n\n.modalStyleDark {}\n\n.delPopContainer .modal-content {\n  border-radius: 10px;\n  min-width: 399px;\n}\n\n.larg_model .modal-dialog {\n  max-width: 100% !important;\n}\n\n.larg_model .modal-content {\n  /* display: inline-block; */\n  height: 100%;\n  max-width: 900px;\n  margin: auto;\n  border-radius: 54px !important;\n  background: #FFF;\n  padding: 53px 53px 23px;\n}\n\n.larg_model .modal-header {\n  padding: 0px 0px 23px;\n  border-bottom: 1px dashed #D4D9EE;\n  display: block;\n}\n\nbody .btn-primary:hover {\n  background-color: transparent;\n  border-color: #131F43;\n  color: #131F43;\n  fill: #131F43;\n  border: 1px solid;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: .375rem 2.25rem .375rem .75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(../../assets/select_arow.svg) !important;\n}\n\nthead .CustomTable_tableheadlight__HuHZw th:first-child,\nthead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  border-radius: 5px 0 0 0px;\n  display: math;\n}\n\nth:first-child {\n  border-radius: 0px;\n  position: absolute;\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 270px;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n    overflow-x: hidden !important;\n  }\n\n  .cont2 {\n    height: auto !important;\n    padding-bottom: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n\n@media only screen and (max-width: 767px) {\n  .sectionright {\n    float: unset !important;\n  }\n\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px 10px 15px !important;\n  }\n\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 110px;\n  }\n\n  .delPopContainer .modal-content {\n    min-width: 100%;\n  }\n\n  .delPopContainer .modal-body {\n    padding: 15px;\n  }\n\n  .larg_model .modal-content {\n    border-radius: 20px !important;\n    padding: 22px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n\n  /*.tableheadlight th {\n    min-width: 120px;\n  } */\n}\n\n/* vk new changes */\n.active_show_outer {\n\n  h2 {\n    color: var(--Font-black, #0B0D0F);\n    font-family: Urbanist;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    @media screen and (max-width:768px) {\n      margin-top: 15px;\n    }\n  }\n\n  .active_show_inner {\n    width: 100%;\n    display: block;\n\n    .act_box_img {\n      margin-bottom: 12px;\n      min-height: 400px;\n      object-fit: cover;\n      overflow: hidden;\n      height: 400px;\n      max-height: 400px;\n      @media (max-width: 767px) {\n        min-height: 300px;\n        height: 300px;\n        max-height: 300px;\n      }\n      img {\n        max-height: 400px;\n        /* align-self: stretch; */\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: cover;\n      }\n    }\n\n    .act_box_cnt {\n      width: 100%;\n      display: block;\nsvg{\n  flex-shrink: 0;\n}\n      .act_box_bdg {\n        width: 100%;\n        margin-bottom: 12px;\n\n        span {\n          background: url(../../assets/ongoing.png) right top no-repeat;\n          width: 111px;\n          display: block;\n          height: 34px;\n          color: var(--White, #FFF);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 500;\n          padding: 3px 8px;\n        }\n\n        .sold {\n          background: url(../../assets/sold.png) right top no-repeat !important;\n        }\n\n      }\n\n      h3 {\n        color: var(--Secondary, #132941);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 26.304px;\n        margin: 0;\n      }\n\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 5px;\n\n        span {\n          color: var(--Light-1, #736B66);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 26.304px;\n        }\n\n        .timezone_code_pill {\n          display: inline-block;\n          padding: 2px 8px;\n          margin-left: 4px;\n          background: #e0f2fe;\n          color: #0369a1;\n          font-size: 12px;\n          font-weight: 600;\n          letter-spacing: 0.02em;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* vk new changes */\n#attent_details_row1{\n    margin-bottom: 0 !important;\n}\n.attent_details {\n  .attent_details_inner {\n    display: flex;\n    gap: 61px;\n    padding: 20px;\n    border-radius: 5px;\n    background: #FFF;\n    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n    align-items: center;\n\n    @media (max-width: 576px) {\n      display: block !important;\n    }\n\n    @media (max-width: 992px) {\n      display: flex;\n      gap: 20px;\n      align-items: start;\n    }\n\n    .attent_details_inner_l {\n      img {\n        width: 187px;\n        height: 207px;\n        flex-shrink: 0;\n        object-fit: cover;\n      }\n    }\n\n    .attent_details_inner_r {\n      flex: 1;\n\n      .attent_details_row {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 28px;\n\n        @media (max-width: 992px) {\n          margin-bottom: 0px;\n          display: inline-block;\n          width: 100%;\n        }\n\n        .attent_details_row_box {\n          flex: 1;\n          width: 22%;\n\n          @media (max-width: 576px) {\n            margin: 15px 0px 10px !important;\n            width: 100% !important;\n          }\n\n          @media (max-width: 992px) {\n            margin-bottom: 15px;\n            float: left;\n            margin-right: 0;\n            width: 50%;\n            padding-right: 10px;\n          }\n\n          p {\n            margin-bottom: 10px;\n            color: #727272;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n          }\n\n          h5 {\n            color: #131F43;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            word-wrap: break-word;\n          }\n        }\n      }\n\n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n .showbox_sec{\n      display: flex;\n    justify-content: flex-start;\n    gap: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    @media screen and (max-width:500px) {\n      justify-content: center;\n    }\n }\n.show_box_main {\n  margin: 10px 0px;\n\n  .show_box {\n    min-height: 600px;\n    width: 300px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-right: 18px;\n    }\n    @media (max-width: 767px) {\n      min-height: 500px;\n      width: 200px !important;\n    }\n\n    img {\n      max-height: 400px;\n      height: 100%;\n      width: 100%;\n\n      @media (max-width: 767px) {\n        max-height: 300px !important;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0px !important;\n    }\n  }\n\n  .no_show_box {\n    width: 350px;\n    margin: 0 auto 20px;\n    display: block;\n  \n    @media (max-width: 767px) {\n      width: 250px !important;\n    }\n  \n    img {\n      max-height: 450px;\n      height: 100%;\n      width: 100%;\n  \n      @media (max-width: 767px) {\n        max-height: 350px !important;\n      }\n    }\n    h6 {\n      color: #000;\n      text-align: center;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 20px;\n      @media only screen and (max-width: 600px) {\n        font-size: 20px;\n      }\n    }\n  }\n  \n\n}\n\n.attent_flex {\n  justify-content: space-between !important;\n  gap: 30px;\n  align-items: center;\n\n  h5 {\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n .profilepicdiv{\n    padding: 10px;\n    border-radius: 5px;\n    text-align: center;\n    @media screen and (max-width:768px) {\n        padding: 0 10px 10px 10px;\n    }\n}\n\n.profilepic{\n    width: 110px;\n    height: 110px;\n    border-radius: 5px;\n}\n.editbtnsection{\n    text-align: center;\n    margin-top: 0%;\n}\n\n#penicon{\n    margin-left:106px;\n    font-size: 14px;\n    background-color: $lightthemetext;\n    padding: 5px;\n    border-radius: 50%;\n    color: #e9ecef;\n    cursor: pointer;\n\n     &:hover{\n        background-color: $primary-btncolor;\n     }\n}\n\n.uploadfield{\n    border: 1px solid #dee2e6;\n    background-color: #f8f9fa;\n    padding: 6px 0px 0px 3px;\n    width: 90px;\n    margin-left: 130%;\n    margin-top: -55%;\n    border-radius:5px;\n}\n\n.sizeHint {\n  font-size: 11px;\n  color: #6c757d;\n  display: block;\n  margin-top: 4px;\n}\n.uploadicon{\n    color: $black-color;\n    font-size: 18px;\n    cursor: pointer;\n\n    &:hover{\n        color: $primary-btncolor;\n     }\n}\n.crossicon{\n    color: $black-color;\n    font-size: 16px;\n    margin-left: 40px;\n    cursor: pointer;\n\n    &:hover{\n       color: $primary-btncolor;\n     }\n\n}\n\n\n@media only screen and (max-width: 600px) {\n    .editbtnsection{\n        margin-top: 10px;\n    }\n  }\n\n  @media only screen and (max-width: 600px) {\n    .editbtnsection{\n        margin-top: 0;\n    }\n  }\n\n  @media only screen and (max-width: 430px) {\n    .uploadfield{\n        margin-left: 95%;\n        margin-top: -6%;\n    }\n  }\n\n\n@media only screen and (max-width: 400px) {\n    .editbtnsection{\n        margin-top: 0;\n    }\n  }\n\n\n  \n@media only screen and (max-width: 350px) {\n    .editbtnsection{\n        margin-top: 0;\n    }\n    #penicon{\n        margin-left:90px;\n    }\n    .uploadfield{\n        margin-left: 70%;\n        margin-top: -5%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `profilePic_dashboard__JPxt7`,
	"dashboardContain": `profilePic_dashboardContain__IMIGu`,
	"bodythemedark": `profilePic_bodythemedark__Xwoji`,
	"cont2": `profilePic_cont2__saMR8`,
	"top_header": `profilePic_top_header__UU2J1`,
	"top_header_inner": `profilePic_top_header_inner__Sl2vE`,
	"subLink": `profilePic_subLink__VStYM`,
	"cst_vendr": `profilePic_cst_vendr__ESENQ`,
	"form-control": `profilePic_form-control__Tp7ew`,
	"footer": `profilePic_footer__tBwon`,
	"bodythemelight": `profilePic_bodythemelight__HLdOE`,
	"bodythemeNew": `profilePic_bodythemeNew__wnugN`,
	"headerthemelight": `profilePic_headerthemelight__PilSB`,
	"headerthemedark": `profilePic_headerthemedark__iPgL8`,
	"menuthemelight": `profilePic_menuthemelight__2Ss4L`,
	"menuthemedark": `profilePic_menuthemedark__QVe1W`,
	"menulinklight": `profilePic_menulinklight__lsCgn`,
	"menulinkdarkSelected": `profilePic_menulinkdarkSelected__zso2-`,
	"menulinklightSelected": `profilePic_menulinklightSelected__wjHCW`,
	"menulinkdark": `profilePic_menulinkdark__zJdzP`,
	"sub_arrow": `profilePic_sub_arrow__Ut93b`,
	"headinglight": `profilePic_headinglight__xg0Xf`,
	"headingdark": `profilePic_headingdark__htXGr`,
	"searchboxlight": `profilePic_searchboxlight__ae0aZ`,
	"searchboxdark": `profilePic_searchboxdark__1jar8`,
	"tableheadlight": `profilePic_tableheadlight__FifrR`,
	"tableheaddark": `profilePic_tableheaddark__7Y6BR`,
	"table": `profilePic_table__HyVds`,
	"table-borderless": `profilePic_table-borderless__BV-NV`,
	"left-section": `profilePic_left-section__MjWNW`,
	"tablebodylight": `profilePic_tablebodylight__66ENh`,
	"tablebodydark": `profilePic_tablebodydark__D2j26`,
	"paginationlight": `profilePic_paginationlight__3KxA8`,
	"paginationdark": `profilePic_paginationdark__-hPqT`,
	"formthemelight": `profilePic_formthemelight__VoAYe`,
	"formthemedark": `profilePic_formthemedark__q3ROm`,
	"viewformlight": `profilePic_viewformlight__7Bm4E`,
	"permissionboxlight": `profilePic_permissionboxlight__O08yh`,
	"permissionboxdark": `profilePic_permissionboxdark__9naD0`,
	"errormsgclr": `profilePic_errormsgclr__wj5Bj`,
	"graphclrlight": `profilePic_graphclrlight__OG2D2`,
	"graphclrdark": `profilePic_graphclrdark__liaB8`,
	"card1bglight": `profilePic_card1bglight__8i9cS`,
	"card1bgdark": `profilePic_card1bgdark__kZ1aJ`,
	"card2bglight": `profilePic_card2bglight__w6FpT`,
	"card2bgdark": `profilePic_card2bgdark__mm3Tx`,
	"card3bglight": `profilePic_card3bglight__Ovh5i`,
	"card3bgdark": `profilePic_card3bgdark__Pdved`,
	"card4bglight": `profilePic_card4bglight__Bp80a`,
	"card4bgdark": `profilePic_card4bgdark__T9zfK`,
	"actionbtnlight": `profilePic_actionbtnlight__YVuTW`,
	"actionbtndark": `profilePic_actionbtndark__w+xsH`,
	"profiledropdownlight": `profilePic_profiledropdownlight__wpumk`,
	"profiledropdowndark": `profilePic_profiledropdowndark__bSVZz`,
	"settingsection": `profilePic_settingsection__kIfIu`,
	"addform": `profilePic_addform__hkTYm`,
	"savebtn": `profilePic_savebtn__1h+DM`,
	"profile_conatiner": `profilePic_profile_conatiner__-jZMC`,
	"ag-theme-alpine": `profilePic_ag-theme-alpine__IEZg2`,
	"ag-row": `profilePic_ag-row__bHHn9`,
	"formbtn": `profilePic_formbtn__-PVDt`,
	"resetbtn": `profilePic_resetbtn__sI9bP`,
	"addBtn": `profilePic_addBtn__FYpoo`,
	"addDltBtn": `profilePic_addDltBtn__xf7b6`,
	"addbtnlight": `profilePic_addbtnlight__Hl6y0`,
	"addbtndark": `profilePic_addbtndark__lJxYj`,
	"cust_addBtn": `profilePic_cust_addBtn__OFVhY`,
	"deleteBtn": `profilePic_deleteBtn__cwMHm`,
	"confirmBtn": `profilePic_confirmBtn__d3Z+t`,
	"delPopContainer": `profilePic_delPopContainer__Dc+CD`,
	"modal-body": `profilePic_modal-body__Ijxbc`,
	"delet_icon": `profilePic_delet_icon__enafO`,
	"arrowback": `profilePic_arrowback__Qcy5h`,
	"drpdwn_btn": `profilePic_drpdwn_btn__7J9lx`,
	"empname": `profilePic_empname__tXDxk`,
	"navitemli": `profilePic_navitemli__hbNv8`,
	"tabnavli": `profilePic_tabnavli__54qZg`,
	"settingsgeneral": `profilePic_settingsgeneral__HG2OY`,
	"settingslinks": `profilePic_settingslinks__Shzq-`,
	"dropdown_menu_contain": `profilePic_dropdown_menu_contain__UzzMt`,
	"dropdown_item": `profilePic_dropdown_item__PXcOe`,
	"profile_arrrow_dwn": `profilePic_profile_arrrow_dwn__oUjg2`,
	"dateinputbox1": `profilePic_dateinputbox1__QnA5w`,
	"modal-content": `profilePic_modal-content__dUSXG`,
	"larg_model": `profilePic_larg_model__TJTEo`,
	"modal-dialog": `profilePic_modal-dialog__oJMWf`,
	"modal-header": `profilePic_modal-header__T95WG`,
	"btn-primary": `profilePic_btn-primary__pOjcJ`,
	"form-select": `profilePic_form-select__4VlO2`,
	"CustomTable_tableheadlight__HuHZw": `profilePic_CustomTable_tableheadlight__HuHZw__k4Q1x`,
	"CustomTable_tableheaddark__nwqb4": `profilePic_CustomTable_tableheaddark__nwqb4__R+14e`,
	"sectionright": `profilePic_sectionright__6xmsp`,
	"exer_modal_contain": `profilePic_exer_modal_contain__Y303a`,
	"active_show_outer": `profilePic_active_show_outer__ecfb9`,
	"active_show_inner": `profilePic_active_show_inner__ywVsc`,
	"act_box_img": `profilePic_act_box_img__pQOvX`,
	"act_box_cnt": `profilePic_act_box_cnt__Q0+EM`,
	"act_box_bdg": `profilePic_act_box_bdg__uS3WM`,
	"sold": `profilePic_sold__afaUn`,
	"timezone_code_pill": `profilePic_timezone_code_pill__UO0TG`,
	"attent_details_row1": `profilePic_attent_details_row1__eGaU8`,
	"attent_details": `profilePic_attent_details__b2Uxf`,
	"attent_details_inner": `profilePic_attent_details_inner__AkUP-`,
	"attent_details_inner_l": `profilePic_attent_details_inner_l__IHikX`,
	"attent_details_inner_r": `profilePic_attent_details_inner_r__lr-A3`,
	"attent_details_row": `profilePic_attent_details_row__DPygr`,
	"attent_details_row_box": `profilePic_attent_details_row_box__DDFLY`,
	"attent_details_row_last": `profilePic_attent_details_row_last__UTfPc`,
	"interesting_fact": `profilePic_interesting_fact__zkBjI`,
	"showbox_sec": `profilePic_showbox_sec__eifjN`,
	"show_box_main": `profilePic_show_box_main__v58Wx`,
	"show_box": `profilePic_show_box__y1yHc`,
	"no_show_box": `profilePic_no_show_box__t9Ofu`,
	"attent_flex": `profilePic_attent_flex__YF6Ld`,
	"profilepicdiv": `profilePic_profilepicdiv__1MwzM`,
	"profilepic": `profilePic_profilepic__6MpcF`,
	"editbtnsection": `profilePic_editbtnsection__cDMXa`,
	"penicon": `profilePic_penicon__3jn1F`,
	"uploadfield": `profilePic_uploadfield__xrjjw`,
	"sizeHint": `profilePic_sizeHint__WUBgz`,
	"uploadicon": `profilePic_uploadicon__blB0i`,
	"crossicon": `profilePic_crossicon__ou0Mn`
};
export default ___CSS_LOADER_EXPORT___;
